import { render, staticRenderFns } from "./PerformanceFeeForm.vue?vue&type=template&id=0e7216b9&"
import script from "./PerformanceFeeForm.vue?vue&type=script&lang=js&"
export * from "./PerformanceFeeForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports